export default __webpack_public_path__ + "static/media/Bag.1e92479f.png";